export type ProductDemoState = {
  mode: 'demo';
  startedAt: string;
};

const DEMO_MODE_KEY_PREFIX = 'rentify:product-demo-mode';

export const getProductDemoModeKey = (userId: number | string) =>
  `${DEMO_MODE_KEY_PREFIX}:${userId}`;

const parseState = (raw: string | null): ProductDemoState | null => {
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as Partial<ProductDemoState>;

    if (parsed.mode !== 'demo' || typeof parsed.startedAt !== 'string') {
      return null;
    }

    return {
      mode: 'demo',
      startedAt: parsed.startedAt,
    };
  } catch {
    return null;
  }
};

const canUseLocalStorage = () => typeof window !== 'undefined';

export const productDemoStorage = {
  get(userId?: number | string | null): ProductDemoState | null {
    if (!userId || !canUseLocalStorage()) return null;

    return parseState(localStorage.getItem(getProductDemoModeKey(userId)));
  },

  isEnabled(userId?: number | string | null) {
    return Boolean(this.get(userId));
  },

  enable(userId: number | string, startedAt = new Date().toISOString()) {
    if (!canUseLocalStorage()) return;

    localStorage.setItem(
      getProductDemoModeKey(userId),
      JSON.stringify({
        mode: 'demo',
        startedAt,
      } satisfies ProductDemoState),
    );
  },

  disable(userId?: number | string | null) {
    if (!userId || !canUseLocalStorage()) return;

    localStorage.removeItem(getProductDemoModeKey(userId));
  },
};
